<div class="cohorts-container">
	<div class="content">
		<router-outlet></router-outlet>
	</div>
</div>
